/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NextSessions from './NextSessions';
import { useDispatch } from 'react-redux';
import HighResAlert from './HighResAlert';
import { useHistory } from 'react-router-dom';
import { Box, Grid } from '@material-ui/core';
import { topicAPI } from 'src/api/modules/topic';
import { organsAPI } from 'src/api/modules/organs';
import { bitacoraApi } from 'src/api/modules/bitacora';
import SimpleList from 'src/common/components/SimpleList';
import { actions as selectOrgano } from '../../redux/ducks/selectedCollegiateBody';
import notice from 'src/common/components/Notice';

const Start = () => {
	const user = useSelector((state) => state.auth.user);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const organo = useSelector((state) => state.organos.organo);
	const history = useHistory();
	const dispatch = useDispatch();
	const [SeRe, setSeRe] = useState();
	const [resAlert, setResAlert] = useState(false);
	const [isSendEmail, setIsSendEmail] = useState(false);
	const [listOrg, setListOrg] = useState([]);
	const filial = localStorage.getItem('type');
	const showAll = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];
	const showMore = [
		'ADMINISTRADOR GENERAL',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'RESPONSABLE DE SEGUIMIENTO',
	];

	useEffect(() => {
		if (
			systemLevelRole === 'ENLACE' ||
			systemLevelRole === 'RESPONSABLE DE SEGUIMIENTO'
		)
			getAlert(user.id);

		if (showAll.includes(systemLevelRole) === true && filial === null) {
			setListOrg([]);
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setListOrg(response);
					}
				})
				.catch(() => notice('Ocurrio un error', 'error'));
		} else setListOrg(user.organos);
	}, []);

	const getAlert = (idUser) => {
		topicAPI
			.getAlertResolutions(idUser)
			.then((response) => {
				if (response?.temas?.length > 0) {
					let pendingResolutions = [
						...new Set(
							response.temas.map((item) => {
								return {
									idSession: item.sesionId,
									sesion: `${item.numeroSesion}`,
								};
							})
						),
					];
					setResAlert(true);
					setIsSendEmail(true);
					setSeRe(pendingResolutions);
				}
			})
			.catch((error) =>
				notice('Ocurrio un error al obtener alerta de resoluciones')
			);
	};

	const onDetail = (organo) => {
		dispatch(selectOrgano.setOrgano({ ...organo }));
		history.push('/consejos-y-comites/' + organo.id);
	};

	const sendNotificationEmail = (id_Sesion) => {
		topicAPI
			.noitifyResponsableView(id_Sesion)
			.then((response) => {})
			.catch((error) => notice('Ocurrio un error', 'error'));
	};

	const addBinnacleTrackView = (numeroResolución) => {
		const data = {
			accion: `El usuario ${user.nombre} ${user.apellidoPaterno} ${user.apellidoMaterno} ya ha visto las resoluciones de la sesión ${numeroResolución}`,
		};
		bitacoraApi.post(data);
	};
	const onConfirmAlert = (idSesion, numeroSesion, isSendEmail) => {
		setResAlert(false);
		if (systemLevelRole === 'ENLACE') addBinnacleTrackView(numeroSesion);

		if (systemLevelRole === 'ENLACE' && isSendEmail) sendNotificationEmail(idSesion);
		history.push('/seguimiento/agregar-documentacion-resoluciones/' + idSesion);
	};

	const onSearch = () => {
		bitacoraApi.post({ accion: 'Ingreso a la vista de Búsqueda Avanzada' });
		history.push(`/busqueda-avanzada`);
	};

	return (
		<Box>
			<Grid container spacing={2}>
				{showMore.includes(systemLevelRole) === true && filial === null ? (
					<Button
						onClick={onSearch}
						className="btn btn-outline-primary btn-lg btn-block"
						spacing={2}
					>
						Búsqueda Avanzada{' '}
					</Button>
				) : (
					'  '
				)}

				{systemLevelRole === 'OPERADOR DE SEGURIDAD' ||
				systemLevelRole === 'RESPONSABLE CASIA' ? (
					<div className="text-center mt-lg-15">
						<h1 style={{ color: '#DD052B' }}>
							Sistema de Administración de Órganos Colegiados
						</h1>
					</div>
				) : (
					<>
						<Grid item xs={12} md={7} lg={8}>
							<SimpleList
								data={listOrg}
								action={onDetail}
								changeTitle={showAll.includes(systemLevelRole)}
							/>
						</Grid>
						<Grid item xs={12} md={5} lg={4}>
							<NextSessions />
						</Grid>
						<div className="mt-lg-9">
							<HighResAlert
								isSendEmail={isSendEmail}
								open={resAlert}
								setOpen={setResAlert}
								onConfirm={onConfirmAlert}
								organo={organo}
								sessions={SeRe}
							/>
						</div>
					</>
				)}
			</Grid>
		</Box>
	);
};

export default Start;
